<span [class]="(className ? className : '') + ' tag'">
  {{label}}
</span>
